import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NotifyComponent',
  props: {
    text: {
      type: String,
    },
    status: {
      type: String as PropType<'done' | 'error' | 'info'>,
      default: 'error',
    },
    size: {
      type: String as PropType<'sm' | 'lg'>,
      required: false,
      default: 'sm',
    },
    closable: {
      type: Boolean,
      required: false,
    },
  },
  setup() {
    return {}
  },
})
